import React, { useCallback } from "react";
import { styled } from "@mui/material/styles";
import { useSelector } from "react-redux";
import { OPACITY_GRID_EVENT } from "./constants";

const PREFIX = 'TileSide'

const classes = {
  root: `${PREFIX}-root`,
  north: `${PREFIX}-north`,
  east: `${PREFIX}-east`,
  south: `${PREFIX}-south`,
  west: `${PREFIX}-west`,
  soloCentered: `${PREFIX}-soloCentered`,
}

const TileSideContainer = styled('div')((
  {
    theme
  }
) => {
  return {
    [`& .${classes.root}`]: {

    },
    [`& .${classes.north}`]: {
      width: '100%',
      height: '6px',
      position: 'absolute',
      left: '0',
      top: '0.5rem',
    },
    [`& .${classes.east}`]: {
      height: '100%',
      width: '6px',
      position: 'absolute',
      top: '0',
      right: '0.5rem',
    },
    [`& .${classes.south}`]: {
      width: '100%',
      height: '6px',
      position: 'absolute',
      bottom: '0.5rem',
      left: '0'
    },
    [`& .${classes.west}`]: {
      height: '100%',
      width: '6px',
      position: 'absolute',
      top: '0',
      left: '0.5rem',
    },
  }
})

export const TileSide = ({ tile }) => {

  const currentLayout = useSelector(state => state.configurator?.layout)

  const sidesToMap = ["north", "east", "south", "west"]

  const sideColor = {
    frame: "white",
    ipad: "red",
    screen: "blue",
    fazlogo: "green",
    designlogo: "orange",
  }

  const isOnASingleTile = useCallback((item) => {
    return !tile[item].endTile || (JSON.stringify(tile[item].endTile) === JSON.stringify(tile[item].startTile))
  }, [tile]);

  const getLineWidth = (item) => {
    if ((item === 'north' || item === 'south') && isOnASingleTile(item)) {
      return 1;
    } else if ((item === 'east' || item === 'west') && isOnASingleTile(item)) {
      return 1;
    } else if ((item === 'north' || item === 'south') && tile[item].size === 'custom' &&
      ((tile[item].endTile.row === tile.row) && (tile[item].endTile.column === tile.column))) {
      return tile[item].endTile.column > tile[item].startTile.column ? 2 : 3;
    } else if ((item === 'north' || item === 'south') && tile[item].size === 'custom' &&
      (tile[item].startTile.row === tile.row) && (tile[item].startTile.column === tile.column)) {
      return tile[item].startTile.column > tile[item].endTile.column ? 2 : 3;
    } else if ((item === 'east' || item === 'west') && tile[item].size === 'custom' &&
      ((tile[item].endTile.column === tile.column) && (tile[item].endTile.row === tile.row))) {
      return tile[item].endTile.row > tile[item].startTile.row ? 4 : 5;
    } else if ((item === 'east' || item === 'west') && tile[item].size === 'custom' &&
      (tile[item].startTile.column === tile.column) && (tile[item].startTile.row === tile.row)) {
      return tile[item].startTile.row > tile[item].endTile.row ? 4 : 5;
    }

    return 6;
  }


  const lineSizes = {
    1: 'calc(100% - 1.10rem)',
    2: 'calc(100% - 0.5rem)',
    3: 'calc(100% - 0.5rem)',
    4: 'calc(100% - 0.5rem)',
    5: 'calc(100% - 0.5rem)',
    6: null,
  }

  return (
    <TileSideContainer>
      {sidesToMap.map((item) => {
        const isFrameTransparent = tile[item]?.type === 'frame' && (!tile[item]?.file && !tile[item]?.imageUrl)
        if (sideColor.hasOwnProperty(tile[item].type)) {
          const tmp = getLineWidth(item);
          return (
            <div
              className={classes[item]}
              key={`tile-${tile.row}-${tile.column}-${item}`}
              style={{
                margin: `${tmp === 5 ? '0.5rem' : 0} ${tmp === 2 ? '0.5rem' : 0} ${tmp === 4 ? '0.5rem' : 0} ${tmp === 3 ? '0.5rem' : 0}`,
                backgroundColor: isFrameTransparent ? 'transparent' : sideColor[tile[item].type],
                border: isFrameTransparent ? '1px solid white' : 'none',
                opacity: currentLayout !== 'normal' ? OPACITY_GRID_EVENT : '1',
                width: (item === 'south' || item === 'north') ? lineSizes[tmp] : null,
                height: (item === 'east' || item === 'west') ? lineSizes[tmp] : null,
                left: (item === 'south' || item === 'north') && isOnASingleTile(item) ? '50%' : null,
                top: (item === 'east' || item === 'west') && isOnASingleTile(item) ? '50%' : null,
                transform: (item === 'south' || item === 'north') && isOnASingleTile(item) ? 'translateX(-50%)' :
                  (item === 'east' || item === 'west') && isOnASingleTile(item) ? 'translateY(-50%)' : ''
              }}
            />
          )
        } else
          return null
      })}
    </TileSideContainer>
  )
}